import tooltipClasses from "@mui/material/Tooltip/tooltipClasses";
import { typographyResponsive } from "../../styles/utils/typography.module";
export const MuiTooltipTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            arrow: {
                color: dt.color.inverseSurface,
                [`.${tooltipClasses.tooltipPlacementTop} &::before`]: {
                    borderBottomRightRadius: "3px",
                },
                [`.${tooltipClasses.tooltipPlacementRight} &::before`]: {
                    borderBottomLeftRadius: "3px",
                },
                [`.${tooltipClasses.tooltipPlacementBottom} &::before`]: {
                    borderTopLeftRadius: "3px",
                },
                [`.${tooltipClasses.tooltipPlacementLeft} &::before`]: {
                    borderTopRightRadius: "3px",
                },
                [`.${tooltipClasses.popper}.Pxl-light &::before`]: {
                    border: `${dt.brand.borderWidth.xSmall} solid ${dt.color.palette.neutrals[90]}`,
                    color: dt.color.inverseOnSurface,
                },
            },
            tooltip: Object.assign(Object.assign({}, typographyResponsive(dt, "caption")), { display: "flex", flexDirection: "row", columnGap: dt.inline.small, color: dt.color.inverseOnSurface, padding: `${dt.inset.squish.medium.vertical} ${dt.inset.squish.medium.horizontal}`, borderRadius: dt.brand.borderRadius.small, backgroundColor: dt.color.inverseSurface, ".Pxl-light &": {
                    border: `${dt.brand.borderWidth.xSmall} solid ${dt.color.palette.neutrals[90]}`,
                    color: dt.color.onSurface.key,
                    background: dt.color.surface.key,
                    boxShadow: dt.elevation.level4,
                } }),
        },
    };
};
